import React from "react";
import Fallback from "app/components/Fallback";
const SchoolDashboard = React.lazy(() =>
  import("app/modules/dashboard/Dashboard")
);

export const DashboardPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <SchoolDashboard {...props} />
  </React.Suspense>
);
